import { defineStaticService } from '@wix/static-service'
import type { StaticServiceDefinition } from '@wix/static-service'

export type Serializable = string | number | boolean | null | Serializable[] | { [key: string]: Serializable }

export type IPublicApiCallerConfig = {
	callPublicApi: <T = Serializable>(
		appDefinitionId: string,
		methodPath: string | string[],
		args?: Serializable[]
	) => Promise<T>
}

export interface IPublicApiCaller {
	callPublicApi<T = Serializable>(
		appDefinitionId: string,
		methodPath: string | string[],
		args?: Serializable[]
	): Promise<T>
}

export type IPublicApiCallerDefinition = StaticServiceDefinition<IPublicApiCaller, IPublicApiCallerConfig>

export const PublicApiCallerDefinition = defineStaticService<IPublicApiCaller, IPublicApiCallerConfig>(
	'@wix/site-service-public-api-caller'
)
